import { postObject } from "./trackerService";

const dbName = 'scans';
const storeName = 'scansToSync';


export const saveScanInOffline = async (scan, url, apiKey) => {
    const dbr = indexedDB.open(dbName);
    dbr.onsuccess = () => {
        const db = dbr.result;
        if (!db.objectStoreNames.contains(storeName)) {
            var version = db.version;
            db.close();
            var request = indexedDB.open(dbName, version + 1);
            request.onupgradeneeded = (e) => {
                const db = e.target.result;
                db.createObjectStore(storeName, { keyPath: 'id', autoIncrement: true });
            }
            request.onsuccess = () => {
                const db = request.result;
                saveScan(db, scan, url, apiKey);
            }
        } else {
            saveScan(db, scan, url, apiKey);
        }
    }
}

const saveScan = (db, scan, url, apiKey) => {
    const tx = db.transaction(storeName, 'readwrite');
    tx.objectStore(storeName).add({ ...scan, url: url, apiKey: apiKey });
    tx.commit();
    db.close();
}

export const syncScans = () => {
    const dbr = indexedDB.open('scans');
    dbr.onsuccess = () => {
        const db = dbr.result;
        const scansr = db.transaction(storeName, 'readwrite').objectStore(storeName).getAll();
        scansr.onsuccess = async () => {
            const scans = scansr.result;
            const scansIdsToRemove = [];

            await Promise.all(scans.map(async ({ url, apiKey, ...scan }) => {
                try {
                    const response = await postObject(url, scan, apiKey, false);
                    if (response.status === 200 || response.status === 201) {
                        scansIdsToRemove.push(scan.id)
                    }
                } catch (error) { }
            }));

            const tx = db.transaction(storeName, 'readwrite');
            for (var id of scansIdsToRemove) {
                tx.objectStore(storeName).delete(id);
            }
            tx.commit();
        }
    }
}